import getRouterBasename from '@/lib/router';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import AuthCallback from 'pages/AuthCallback';
import Element from 'pages/Element';
import Env from 'pages/Env';
import Home from 'pages/Home';
import Login from 'pages/Login';
import Thread from 'pages/Thread';
import Signup from './pages/Signup';
import Payment from './pages/Payment';
import SubscriptionDashboard from './pages/SubscriptionDashboard';
import Usage from './pages/Usage';
import ProtectedRoute from './components/ProtectedRoute';
import RootLayout from './components/RootLayout';

export const router = createBrowserRouter(
  [
    {
      element: <RootLayout />,
      children: [
        {
          path: '/',
          element: (
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          ),
        },
        {
          path: '/env',
          element: (
            <ProtectedRoute>
              <Env />
            </ProtectedRoute>
          ),
        },
        {
          path: '/thread/:id?',
          element: (
            <ProtectedRoute>
              <Thread />
            </ProtectedRoute>
          ),
        },
        {
          path: '/element/:id',
          element: (
            <ProtectedRoute>
              <Element />
            </ProtectedRoute>
          ),
        },
        {
          path: '/login',
          element: <Login />,
        },
        {
          path: '/login/callback',
          element: <AuthCallback />,
        },
        {
          path: '/signup',
          element: <Signup />,
        },
        {
          path: '/payment',
          element: (
            <ProtectedRoute allowUnsubscribed>
              <Payment />
            </ProtectedRoute>
          ),
        },
        {
          path: '/payment-success',
          element: (
            <ProtectedRoute allowUnsubscribed>
              <Payment />
            </ProtectedRoute>
          ),
        },
        {
          path: '/dashboard',
          element: (
            <ProtectedRoute allowUnsubscribed>
              <SubscriptionDashboard />
            </ProtectedRoute>
          ),
        },
        {
          path: '/usage',
          element: (
            <ProtectedRoute allowUnsubscribed>
              <Usage />
            </ProtectedRoute>
          ),
        },
        {
          path: '*',
          element: <Navigate replace to="/" />,
        },
      ],
    },
  ],
  { basename: getRouterBasename() }
);
